<template>
  <div>
    <div v-if="video" style="max-width: 800px;margin: 1.5rem auto">
      <div style="position:relative;padding-top:56.25%;">
        <iframe
            v-if="video"
            id="video"
            :src="`https://www.youtube.com/embed/${video}?modestbranding=1&fs=0&rel=0`"
        ></iframe>
      </div>
    </div>
    <div v-if="exercices.length" class="p-4 text-center">
      <exercice-band
          title="Exercices de la semaine"
          title-class="text-secondary h2 mb-3"
          img-width="210px"
          img-height="286.35px"
          :list="exercices">
      </exercice-band>
    </div>
  </div>
</template>

<script>
import ExerciceBand from "@/components/ExerciceBand";

export default {
  name      : "ContenuPrincipal",
  components: {ExerciceBand},
  props     : {
    video    : {type: String},
    exercices: {
      type: Array, default() {
        return []
      }
    }
  },
}
</script>

<style scoped>
iframe {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
</style>